import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const Accordion = ({ title, content, isOpen, onClick }) => {
  return (
    <div className="border-b border-richblack-700">
      <button
        className="flex w-full items-center justify-between py-4 text-left"
        onClick={onClick}
      >
        <span className="text-lg font-medium text-yellow-50">{title}</span>
        <ChevronDown
          className={`h-5 w-5 text-yellow-50 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <div
        className={`overflow-hidden transition-all duration-200 ${
          isOpen ? 'max-h-96' : 'max-h-0'
        }`}
      >
        <div className="py-4 text-richblack-300">{content}</div>
      </div>
    </div>
  );
};

export default Accordion; 